var angular = require("angular");
var ApplicationAPI = require("../api").Application;
var ApplicantAPI = require("../api").Applicant;
var RepositoryAPI = require("../api").Repository;
var enums = require('../../common/enums');
var mapping = require("../../common/question-sets/mapping");
var types = require("../../common/question-sets/types");
var Promise = require('bluebird');

module.exports = QuestionSetController;

function QuestionSetController($scope, $state, $stateParams, $rootScope, ngDialog, $window, $timeout) {
  var vm = this;
  vm.loading = false;
  vm.firstLoad = true;
  vm.loadFailed = false;
  vm.questionsLoaded = false;
  $scope.applicationId = $stateParams.id;

  vm.isPreventingNavigation = false;
  vm.readOnlyView = false;

  vm.bound = [];
  vm.applicationSupportingDocuments = [];
  vm.organisationInformation = {};
  vm.accountType = enums.accountType;

  vm.OneYear = (new Date()).getFullYear() - 1;
  vm.TwoYear = (new Date()).getFullYear() - 2;

  vm.splicedOrganisationQuestionSteps = null;


  $scope.setupConditions = function() {
    // loop through groups/questions to find comparers
    // and bind hide/show fn to a question change event.
    vm.bound.forEach(function(unbind){
      unbind();
    })

    $scope.data.steps.forEach(function(step) {
      step.groups.forEach(function(group) {
        if (group.comparers) setupComparers(group);

        group.questions.forEach(function(question) {
          if (question.comparers) setupComparers(question);

          // this will trigger a change for the comparers to pick up.
          // $timeout is used to wait until the forEach's are complete
          $timeout(function(){
            $scope.$emit("question-init-" + question.id, question);
            $scope.$emit("question-init", question);
          })

        });
      });
    });

    function setupComparers(target) {

      target.comparers.forEach(function(comparer) {
        var comparerType = comparer.$type;

        function fn($event, question) {
          $event.stopPropagation();
          var type = types.comparers[comparerType];
          var bool = type.check(comparer, question);
          target.hide = !bool;
        }

        vm.bound.push($scope.$on("question-change-" + comparer.questionId, fn));
        vm.bound.push($scope.$on("question-init-" + comparer.questionId, fn));
      });
    }
  };

  $scope.$on("question-change", function($event, question){
    vm.preventNavigation();
    if (question.documentId) setDocumentPath(question);
  })

  $scope.$on("question-init", function($event, question){
    if (question.documentId) setDocumentPath(question);
  })

  function setDocumentPath(question){
    RepositoryAPI.GetRepoToken(question.documentId, false).then(function(token) {
      question.documentFullPath = window.conf.doc_repos_url + question.datalink + "?t=" + encodeURIComponent(token);
    });
  }

  function init() {
    vm.loading = true;

    var app = ApplicationAPI.Get($scope.applicationId, "ApplicationLabelView").then(function(result) {
      if (result.status <= 15)
      {
        vm.projectTitle = result.projectTitle;
        vm.userRef = result.userRef;
        vm.projectStatus = result.status;

        vm.totalCost = result.totalCost;
        vm.totalExternallyRaised = result.totalExternallyRaised;
        vm.totalOutstanding = result.totalCost - result.totalExternallyRaised;
        vm.fee = result.fee + result.feeVat;
        vm.feeRate = result.feeRate;
        vm.totalRequested = result.totalRequested;

        if (vm.projectStatus == 1) {
          // edit requested status
          vm.readOnlyView = true;
          vm.isShowingSummary = true;
        }

        return ApplicantAPI.GetApplicantById(result.applicantId, "ApplicantApplicationFinancialDetailsView")
          .then(function(applicantResult){
            vm.organisationInformation = applicantResult;
          });
      } else {
        vm.loadFailed = true;
      }    
    },
    function(result){
      vm.loadFailed = true;
    });

    var questions = ApplicationAPI.GetQuestionSet($scope.applicationId).then(function(result) {
      if (result && result.questionSet)
      {
        var oIndex = null;
        for(var i = 0, len = result.questionSet.steps.length; i < len; i++) {
            if (result.questionSet.steps[i].title === 'Organisation') {
                oIndex = i;
                break;
            }
        }
        if(oIndex){
          vm.splicedOrganisationQuestionSteps = result.questionSet.steps[oIndex];
          result.questionSet.steps.splice(oIndex, 1);
        }
        $scope.data = result.questionSet;
        $scope.full = result;
        vm.questionsLoaded = true;
      }
    });

    getSupportingDocuments();

    return Promise.all([app, questions]).then(function(results) {
      if ($scope.data && $scope.data.steps)
      {
        if (!vm.selected && !vm.readOnlyView) {
          vm.selected = $scope.data.steps[0];
        }

        $scope.setupConditions();
      }
      vm.loading = false;
      vm.firstLoad = false;
    });


  }

  function getSupportingDocuments(){
    ApplicationAPI.GetSupportingDocuments($scope.applicationId).then(function(result){
      vm.applicationSupportingDocuments = result;
    });
  }

  init();

  // $scope.save = function() {
  //   vm.loading = true;
  //   var request = mapping.mapObjectToRequest($scope.full);
  //
  //   ApplicationAPI.Update($scope.applicationId, request).then(function(resp) {
  //     vm.loading = false;
  //     return init();
  //   });
  // };

  // $scope.goToSubmit = function() {
  //   var request = mapping.mapObjectToRequest($scope.full);
  //   vm.loading = true;
  //   ApplicationAPI.Update($scope.applicationId, request).then(function(resp) {
  //     vm.loading = false;
  //     vm.showSubmitSummary = true;
  //     return init();
  //   });
  // };



  vm.backToApplications = function() {
    $state.go("applicant.dashboard.applications");
  };


  vm.showSummary = function(){
    vm.triggerPreventNavigation().then(function(){
      window.scrollTo(0, 0);
      vm.isShowingSummary = true;
      vm.isShowingSupportingDocuments = false;
      vm.selected = null;
      vm.isShowingApplicantInformation = false;
    })
  }
  vm.showSupportingDocuments = function(){
    vm.triggerPreventNavigation().then(function(){
      window.scrollTo(0, 0);
      vm.isShowingSummary = false;
      vm.isShowingSupportingDocuments = true;
      vm.selected = null;
      vm.isShowingApplicantInformation = false;
    })
  }

  vm.showTab = function(step){
    var id = step.id + "";
    vm.triggerPreventNavigation().then(function(){
      window.scrollTo(0, 0);
      vm.selected = $scope.data.steps[indexStep($scope.data.steps, id)];
      vm.isShowingSummary = false;
      vm.isShowingSupportingDocuments = false;
      vm.isShowingApplicantInformation = false;
    })
  }

  vm.showApplicantInformation = function(){
    vm.triggerPreventNavigation().then(function(){
      window.scrollTo(0,0);
      vm.isShowingSummary = false;
      vm.isShowingSupportingDocuments = false;
      vm.selected = null;
      vm.isShowingApplicantInformation = true;
    })
  }

  vm.continue = function(){
    vm.loading = true;
    //readd old organisation questions
    if(vm.splicedOrganisationQuestionSteps != null){
      $scope.full.questionSet.steps.push(vm.splicedOrganisationQuestionSteps);
    }
    var request = mapping.mapObjectToRequest($scope.full);
    var currentStepI = $scope.data.steps.indexOf(vm.selected);
    vm.preventNavigation(false);
    ApplicantAPI.UpdateFinancials(vm.organisationInformation).then(function(){      
      ApplicationAPI.Update($scope.applicationId, request).then(function() {
        return init();
      }).finally(function() {
        if(vm.isShowingSupportingDocuments){
          vm.showApplicantInformation();
        }
        else if(vm.isShowingApplicantInformation){
          vm.showSummary();
        }
        else{
          if (!(currentStepI >= 0)) {
            currentStepI = -1;
          }
          var nextStep = $scope.data.steps[currentStepI + 1];
          if (nextStep) {
            vm.showTab(nextStep);
          } else {
            vm.showSupportingDocuments();
          }
        }
        vm.loading = false;
      });
    })
  }

  var displaySubmitMessage = function () {
    vm.loading = false;
    vm.preventNavigation(false);
    var dialog = ngDialog.open({
      template: require("./dialogs/submitmessage.pug")(),
      controller: require("./dialogs/submitmessage"),
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default"
    });
    dialog.closePromise.then(function (data) {
      $state.go("applicant.dashboard.applications");
    });
  }

  vm.submit = function() {
    vm.loading = true;
    var ncomment = "Submitted by Applicant";
    var nstatus = 10;

    //project status 2 is Edit Allowed Mode
    if(vm.projectStatus == 2){
      ncomment = "Edit request submitted by applicant";
      nstatus = 11;
    }
    ApplicationAPI.UpdateStatus($scope.applicationId, { comment: ncomment, status: nstatus }).then(displaySubmitMessage);

  };

  function indexStep(array, id) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].id == id) {
        return i;
      }
    }
    return -1;
  }

  vm.goBackToEdit = function(step) {
    window.scrollTo(0, 0);
    vm.selected = step;
    vm.isShowingSummary = null;
  };



  var message = "Are you sure you want to navigate away from the application page? Any unsaved progress will be lost.";

  vm.preventNavigation = function(bool){
    if (bool === false) {
      window.onbeforeunload = null;
      vm.isPreventingNavigation = false;
      if (vm.stateChangePreventNav) {
        vm.stateChangePreventNav();
        delete vm.stateChangePreventNav;
      }
      return
    }

    vm.isPreventingNavigation = true;
    window.onbeforeunload = function(e) {
      e = e || window.event;

      if (e) {
        e.returnValue = message;
      }

      return message;
    };

    // return early if already set up
    if (vm.stateChangePreventNav) return;
    vm.stateChangePreventNav = $rootScope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
      e.preventDefault();
      vm.triggerPreventNavigation().then(function(){
        $state.go(toState, toParams);
      })
    })

  }

  vm.triggerPreventNavigation = function(){
    if (!vm.isPreventingNavigation) {
      return Promise.resolve(true);
    }

    return ngDialog.openConfirm({
      template: "\
                <p class='m-r-1'>" + message + "</p>\
                <div class=\"ngdialog-buttons clearfix\">\
                    <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                    <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
                </div>",
      plain: true,
      disableAnimation: true
    })
    .then(function() {
      return ngDialog.openConfirm({
        template: "\
                  <p class='m-r-1'> Are you Sure?</p>\
                  <div class=\"ngdialog-buttons clearfix\">\
                      <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                      <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
                  </div>",
        plain: true,
        disableAnimation: true
      }).then(function(){
        vm.preventNavigation(false);
        return init();
      })
    });
  }

  vm.downloadPrivateFile = function(document){
        RepositoryAPI.GetRepoToken(document.documentId, false, true).then(function(token) {
          var formattedId = (document.documentId).replace(/-/g, '');
          var url = window.conf.doc_repos_url + "dl/"
          + encodeURIComponent(formattedId) + "/"
          + document.fileName
          + "?t=" + encodeURIComponent(token);

          //download file here (opens in new tab)
          $window.open(url, '_blank');
        })
    }



  vm.removeApplicationSupportingDocument = function(doc){
    //remove from database
    ApplicationAPI.RemoveSupportingDocument($scope.applicationId, doc.id).then(function(){
      getSupportingDocuments();
    })
  }

    vm.addSupportingDocument = function(){
    var dialog = ngDialog.open({
      template: require("./dialogs/fileComment.pug")(),
      controller: require("./dialogs/fileComment.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      data: {
        editFilename: false,
        fileName: vm.appSupportingDocUpload.fileName
      }
    });

    dialog.closePromise.then(function (data) {
      if (data.value.action == "save") {
        var uploadDetails = vm.appSupportingDocUpload;
        var details = data.value.fileDetails;
        var fileExt = uploadDetails.fileName.split('.').pop();
        var filename = details.fileName.length > 0 ? details.fileName  : uploadDetails.fileName;
        var document = {
          applicationId: $scope.applicationId,
          blobId: uploadDetails.id,
          blobId: uploadDetails.id,
          fileName: filename,
          fileSize:uploadDetails.fileSize,
          isPublic: false,
          comment: details.comment
        };
        ApplicationAPI.AddSupportingDocument(document).then(function(){
          vm.appSupportingDocUpload = null;
         getSupportingDocuments();
          //refresh reports?
        });
      }
    });
  }

   vm.annualAccountsDocChanged = function(request){
    var aaDoc = request.annualAccounts;
    request.annualAccounts.blobId = aaDoc.id;
  }

  vm.recentBankStatementDocChanged = function(request){
    var rbsDoc = request.bankStatement;
    request.bankStatement.blobId = rbsDoc.id;
  }

}
